// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__24spc","footer":"ChangeClinic_footer__1x0nh"};